import { initCardExpiryInput, isCardExpiryValid } from './card-expiry';
import { isCardCvvValid, isCreditCardValid } from './card-validation';
import { validate } from './validate';

const EWAY_FIELD_NAMES = {
  firstName: 'paymentForm[eway][firstName]',
  lastName: 'paymentForm[eway][lastName]',
  number: 'paymentForm[eway][number]',
  expiry: 'paymentForm[eway][expiry]',
  cvv: 'paymentForm[eway][cvv]',
};

const EWAY_RULES = {
  [EWAY_FIELD_NAMES.firstName]: ['required', 'minLength:2'],
  [EWAY_FIELD_NAMES.lastName]: ['required', 'minLength:2'],
  [EWAY_FIELD_NAMES.number]: ['required', 'creditCard'],
  [EWAY_FIELD_NAMES.expiry]: ['required', 'cardExpiry'],
  [EWAY_FIELD_NAMES.cvv]: ['required', 'cardCvv'],
};

function registerPaymentRules() {
  Iodine.rule('creditCard', (value) => isCreditCardValid(value));
  Iodine.setErrorMessage('creditCard', 'Please enter a valid card number');

  Iodine.rule('cardExpiry', (value) => isCardExpiryValid(value));
  Iodine.setErrorMessage(
    'cardExpiry',
    'Please enter a valid expiry date (MM / YYYY)'
  );

  Iodine.rule('cardCvv', (value) => isCardCvvValid(value));
  Iodine.setErrorMessage('cardCvv', 'Please enter a valid CVV');
}

// Wrap eWay inputs so the shared validate helper can render field errors.
function prepareEwayFormFields(form) {
  const ewayForm = form.querySelector('.eway-form');
  if (!ewayForm || ewayForm.dataset.fieldsPrepared === 'true') return;

  ewayForm.querySelectorAll('input:not([type="hidden"])').forEach((input) => {
    if (input.closest('.field')) return;

    const field = document.createElement('div');
    field.classList.add('field');
    const main = document.createElement('div');
    main.classList.add('field__main');

    input.parentNode.insertBefore(field, input);
    field.appendChild(main);
    main.appendChild(input);
  });

  ewayForm.dataset.fieldsPrepared = 'true';
}

function prepareEwayExpiryField(form) {
  const input = form.querySelector(`[name="${EWAY_FIELD_NAMES.expiry}"]`);
  initCardExpiryInput(input, { expandYearOnBlur: true });
}

function preventDuplicatePaymentSubmits() {
  document.querySelectorAll('form[id^="checkout_payment"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (form.dataset.submitted === 'true') {
        event.preventDefault();
        return;
      }

      if (event.defaultPrevented) return;

      form.dataset.submitted = 'true';

      form
        .querySelectorAll(
          'button[type="submit"], input[type="submit"], button:not([type])'
        )
        .forEach((button) => {
          button.disabled = true;
        });
    });
  });
}

const PAYMENT_PROCESSING_MESSAGE = 'Payment is processing…';

let paymentProcessingOverlay = null;
let isPaymentProcessing = false;

function ensurePaymentProcessingOverlay() {
  if (paymentProcessingOverlay) return paymentProcessingOverlay;

  paymentProcessingOverlay = document.createElement('div');
  paymentProcessingOverlay.className = 'payment-processing-overlay';
  paymentProcessingOverlay.setAttribute('aria-live', 'polite');
  paymentProcessingOverlay.setAttribute('aria-busy', 'true');
  paymentProcessingOverlay.hidden = true;
  paymentProcessingOverlay.innerHTML = `
    <div class="payment-processing-overlay__inner">
      <div class="payment-processing-overlay__spinner" aria-hidden="true"></div>
      <p class="payment-processing-overlay__message">${PAYMENT_PROCESSING_MESSAGE}</p>
    </div>
  `;
  document.body.appendChild(paymentProcessingOverlay);

  return paymentProcessingOverlay;
}

function activatePaymentProcessing() {
  if (isPaymentProcessing) return;
  isPaymentProcessing = true;

  document
    .querySelector('[data-loadable-id="checkout"]')
    ?.classList.add('is-loading');

  const overlay = ensurePaymentProcessingOverlay();
  overlay.hidden = false;
}

function isCompletePaymentUrl(url) {
  return String(url).includes('complete-payment');
}

function setupPayPalLoadingHooks() {
  if (!document.querySelector('.paypal-rest-form')) return;
  if (!('navigation' in window)) return;

  navigation.addEventListener('navigate', (event) => {
    if (isCompletePaymentUrl(event.destination.url)) {
      activatePaymentProcessing();
    }
  });
}

registerPaymentRules();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form').forEach(function (form) {
    if (!form.querySelector('.eway-form')) return;

    prepareEwayFormFields(form);
    prepareEwayExpiryField(form);
    validate(form, { rules: EWAY_RULES });
  });

  preventDuplicatePaymentSubmits();
  setupPayPalLoadingHooks();
});
